import http from './api'
import roomsService from './roomsService'
import type { InvitationKind } from '../types/invitation'

export interface CreateInvitationData {
  roomId?: string
  kind?: InvitationKind
  recipientEmail: string
  role?: string
  /** Football rooms only, manager-only: head-start points applied on accept. */
  startingPoints?: number
}

export interface InvitationPreview {
  token: string
  kind: InvitationKind
  status: string
  expired: boolean
  recipientEmail: string
  senderName: string
  roomName: string
}

class InvitationService {
  async createInvitation(data: CreateInvitationData): Promise<any> {
    const response = await http.post('/invitations', data)
    return response.data
  }

  async getInvitations(): Promise<any[]> {
    const response = await http.get('/invitations')
    return response.data
  }

  async getPreview(token: string): Promise<InvitationPreview> {
    const response = await http.get(`/invitations/preview/${encodeURIComponent(token)}`)
    return response.data
  }

  async markInvitationsAsRead(): Promise<any> {
    const response = await http.get('/invitations/read-all')
    return response.data
  }

  async updateInvitation(
    invitationId: string,
    status: string,
    extras?: { countryCode?: string; city?: string },
  ): Promise<any> {
    const response = await http.patch(`/invitations/${invitationId}`, { status, ...extras })
    return response.data
  }

  async acceptInvitation(
    invitationId: string,
    extras?: { countryCode?: string; city?: string },
  ): Promise<any> {
    const result = await this.updateInvitation(invitationId, 'accepted', extras)
    roomsService.invalidateUserRoomsCache()
    return result
  }

  async declineInvitation(invitationId: string): Promise<any> {
    return this.updateInvitation(invitationId, 'rejected')
  }
}

const invitationService = new InvitationService()
export default invitationService
